module.exports = __webpack_public_path__ + "img/01.1bd61f60.jpg";